export const displayAlert = {
  methods: {
    displayConfirm(title, body, cbkConfirm, okText, cancelText, cbkCancel) {
      const th = this;
      // Alert Confirm
      const html_title = title ? '<div class="snotifyToast__title"><b>' + title + "</b></div>" : "";
      const html_body = body
        ? '<div class="snotifyToast__body">' + body + "</div>"
        : this.$t("misc.continue") + "?";
      const confirmConfig = {
        config: {
          html: html_title + html_body,
          showProgressBar: false,
          closeOnClick: false,
          timeout: 0,
          position: "centerCenter",
          type: "simple",
          backdrop: 0.2,
          cbkConfirm,
          confirmClicked: false,
          buttons: [
            {
              text: cancelText || th.$t("misc.cancel"),
              action: toast => {
                th.$snotify.remove(toast.id);
                th.$nextTick(() => {
                  if (cbkCancel) {
                    cbkCancel();
                  }
                });
              },
              className: "btn btn-footer-panel btn-word-wrap"
            },
            {
              text: okText || th.$t("misc.ok"),
              action: toast => {
                toast.config.confirmClicked = true;
                th.$snotify.remove(toast.id);
                // 2/2/2021 Confirm callback moved on destroyed event. calling custom "cbkConfirm" defined
                /*th.$nextTick(() => {
                  if (cbkConfirm) {
                    cbkConfirm();
                  }
                });*/
              },
              className: "btn btn-footer-panel btn-word-wrap"
            }
          ]
        }
      };

      this.displayAlert(confirmConfig, null);
    },
    displaySimple(title, body, cbk) {
      const config = {
        title: title ? title : "",
        body: body ? body : "",
        config: {
          showProgressBar: false,
          closeOnClick: true,
          timeout: 0,
          backdrop: 0.2,
          position: "centerCenter",
          type: "simple"
        }
      };
      this.displayAlert(config, cbk);
    },

    displayInfo(title, body, cbk) {
      const config = {
        title: title ? title : "Info",
        body: body ? body : "",
        config: {
          showProgressBar: false,
          closeOnClick: true,
          timeout: 0,
          backdrop: 0.2,
          closeOnClickOutside: true, // v-click-outside
          position: "rightBottom",
          type: "info"
        }
      };
      this.displayAlert(config, cbk);
    },

    displaySuccess(title, body, cbk) {
      const config = {
        title: title ? title : "OK",
        body: body ? body : "",
        config: {
          showProgressBar: false,
          closeOnClick: true,
          timeout: 2000,
          position: "rightBottom",
          type: "success",
          backdrop: -1
        }
      };
      this.displayAlert(config, cbk);
    },

    displayWarning(title, body, cbk) {
      const config = {
        title: title ? title : "Warning",
        body: body ? body : "",
        config: {
          showProgressBar: false,
          closeOnClick: true,
          timeout: 3000,
          position: "rightBottom",
          type: "warning",
          backdrop: -1
        }
      };
      this.displayAlert(config, cbk);
    },

    displayError(title, body, cbk) {
      const config = {
        title: title ? title : "Error",
        body: body ? body : "",
        config: {
          showProgressBar: false,
          closeOnClick: true,
          timeout: 0,
          position: "rightBottom",
          type: "error",
          backdrop: -1
        }
      };
      this.displayAlert(config, cbk);
    },

    displayAlert(config, cbkDestroy) {
      const th = this;
      th.$snotify
        .create(config)
        .on("destroyed", function (snotify) {
          if (snotify.config.confirmClicked) {
            snotify.config.cbkConfirm();
          }

          if (cbkDestroy) {
            // clear
            th.$store.dispatch("Alert/Errors/resetVal");
            th.$store.dispatch("Alert/Warnings/resetVal");

            cbkDestroy(snotify.config);
          }
        })
        .on("beforeHide", snotify => {
          snotify.config.backdrop = -1;
        });
    }
  }
};
